import React, { ChangeEvent } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import JabraInput from 'components/Shared/JabraInput';

import { usePrefillableValue } from '../../hooks/usePrefillableValue';
import { EmailViewModel } from '../../types/email';

const Email: React.FunctionComponent<ValueFieldProps<EmailViewModel>> = (props) => {
  const { errors, field, ...restProps } = props;
  const [value, setValue] = usePrefillableValue(
    field.model.name,
    props.value,
    props.onChange,
    field.valueField.name
  );
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent;

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event?.target?.value;
    setValue(newValue);
    props.onChange(field.valueField.name, newValue, restProps.isValid, []);
  };

  return (
    <>
      {!!Label && <Label {...props} />}
      <JabraInput
        type="email"
        id={field.valueField.id}
        name={field.valueField.name}
        value={value}
        jssMetadata={props}
        placeholder={field.model.placeholderText}
        required={field.model.required}
        onChange={onChange}
      />
      {!!FieldValidationErrors && (
        <FieldValidationErrors
          field={field}
          errors={errors.map((error) =>
            !!field.model.validationErrorMessage ? field.model.validationErrorMessage : error
          )}
          {...restProps}
        />
      )}
    </>
  );
};

export default Email;
